import React from "react";
import { SpheraConfirmation } from "@sphera-cloud/component-ui-reactjs";

export const ConfirmDeleteSiteDialog = (props) => {
	return (
		<SpheraConfirmation
			hasAction
			isDangerConfirm
			actionText={props.localizations.Delete}
			cancelText={props.localizations.Cancel}
			onCancel={props.toggleConfirmDeleteDialog}
			onClose={props.toggleConfirmDeleteDialog}
			title={props.localizations.DeleteSiteName + props.card?.name}
			onAction={() => props.deleteSite(props.card)}
		>
			{props.localizations.DeleteSite}
		</SpheraConfirmation>
	);
};
